import axios from 'axios';
import ApiConstants from '../../_Constants/ApiConstants';
import AppConstants from '../../_Constants/AppConstants';
import { aqtStore } from '../../Components/State/Store';
import { withHeader } from '../../Auth';
import { networkError, getSession, logToConsole } from '../../Util';

export var jobSockets = {};

export function fetchLabsAndRasPis() {
  if (getSession() === AppConstants.SESSIONERR) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.SESSIONERR
      })
    });
  }
  let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
  let labsAndThingsPromises = [];
  return axios.get(controllerEndpoint +
      ApiConstants.VIEW_GROUP_LIST_URL,
      withHeader(aqtStore.getState().session.idToken.jwtToken))
    .then(labs => {
      if (labs.hasOwnProperty('data')) {
        logToConsole('Labs: ' + JSON.stringify(labs.data));
        labs.data.forEach(labMap => {
          labsAndThingsPromises.push(
            axios.get(controllerEndpoint +
              ApiConstants.VIEW_GROUP_LIST_URL + '/' +
              labMap.id + '/' +
              ApiConstants.THINGS,
              withHeader(aqtStore.getState().session.idToken.jwtToken))
            .then(rasPis => {
              return {
                lab: labMap,
                rasPis: rasPis.data ? rasPis.data : []
              };
            })
            .catch(error => {
              networkError(error, fetchLabsAndRasPis.name);
              return {
                error: AppConstants.NETWORKERR
              };
            })
          );
        });
        return labsAndThingsPromises;
      } else {
        return {
          error: AppConstants.NOLABS
        }
      }
    })
    .catch(error => {
      networkError(error, fetchLabsAndRasPis.name);
      return {
        error: AppConstants.NETWORKERR
      };
    });
}

export function fetchLabs() {
  if (getSession() === AppConstants.SESSIONERR) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.SESSIONERR
      })
    });
  }
  let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
  return axios.get(controllerEndpoint +
      ApiConstants.VIEW_GROUP_LIST_URL,
      withHeader(aqtStore.getState().session.idToken.jwtToken))
    .then(labs => {
      if (labs.hasOwnProperty('data')) {
        logToConsole('Labs: ' + JSON.stringify(labs.data));
        return labs.data;
      } else {
        return {
          error: AppConstants.NOLABS
        }
      }
    })
    .catch(error => {
      networkError(error, fetchLabs.name);
      return {
        error: AppConstants.NETWORKERR
      };
    });
}

export function fetchRasPis(labId) {
  if (getSession() === AppConstants.SESSIONERR) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.SESSIONERR
      })
    });
  }
  let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
  return axios.get(controllerEndpoint +
      ApiConstants.VIEW_GROUP_LIST_URL + '/' +
      labId + '/' +
      ApiConstants.THINGS,
      withHeader(aqtStore.getState().session.idToken.jwtToken))
    .then(rasPis => {
      if (rasPis.hasOwnProperty('data')) {
        logToConsole('RasPis: ' + JSON.stringify(rasPis.data));
        return rasPis.data;
      } else {
        return {
          error: AppConstants.NOLABS
        }
      }
    })
    .catch(error => {
      networkError(error, fetchRasPis.name);
      return {
        error: AppConstants.NETWORKERR
      };
    });
}

export function getRasPiSetupCommand(rasPiId) {
  if (getSession() === AppConstants.SESSIONERR) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.SESSIONERR
      })
    });
  }
  if (!rasPiId) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.NORASPI
      })
    });
  } else {
    let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
    return axios.get(controllerEndpoint +
        ApiConstants.VIEW_THING_SETUP.replace('thingId', rasPiId),
        withHeader(aqtStore.getState().session.idToken.jwtToken))
      .then(thingSetupCom => {
        if (thingSetupCom.hasOwnProperty('data')) {
          logToConsole('RasPi Setup Command: ' + thingSetupCom.data.cmdLine);
          return {
            data: thingSetupCom.data.cmdLine
          };
       } else {
        return {
          error: AppConstants.NOCMDLINE
        };
       }
      })
      .catch(error => {
        networkError(error, getRasPiSetupCommand.name);
        return {
          error: AppConstants.NETWORKERR
        };
      });
  }
}

export function actionRasPi(labId, rasPiId, actionId) {
  if (getSession() === AppConstants.SESSIONERR) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.SESSIONERR
      })
    });
  }
  if (!rasPiId) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.NORASPI
      })
    });
  } else {
    let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
    return axios.get(controllerEndpoint +
      ApiConstants.VIEW_GROUP_LIST_URL + '/' +
      labId + '/' +
      ApiConstants.THINGS + '/' +
      rasPiId + '/' +
      AppConstants.rasPiAction[actionId].action,
      withHeader(aqtStore.getState().session.idToken.jwtToken))
    .then(rasPiStatus => {
      if (rasPiStatus.hasOwnProperty('data')) {
        logToConsole('RasPi status : ' + JSON.stringify(rasPiStatus.data));
        return { success: rasPiStatus.data };
      } else {
        return { error: AppConstants.SERVERERR }
      }
    })
    .catch(error => {
      networkError(error, actionRasPi.name);
      return {
        error: error.message
      };
    });
  }
}

export function actionRasPiWithBodyAndAckTimeout(labId, rasPiId, actionId, body, ackTimeout) {
  if (getSession() === AppConstants.SESSIONERR) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.SESSIONERR
      })
    });
  }
  if (!rasPiId) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.NORASPI
      })
    });
  } else {
    let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
    return axios.post(controllerEndpoint +
      ApiConstants.VIEW_GROUP_LIST_URL + '/' +
      labId + '/' +
      ApiConstants.THINGS + '/' +
      rasPiId + '/' +
      AppConstants.rasPiAction[actionId].action +
      '?ackTimeout=' + ackTimeout,
      body,
      withHeader(aqtStore.getState().session.idToken.jwtToken))
    .then(rasPiStatus => {
      if (rasPiStatus.hasOwnProperty('data')) {
        logToConsole('RasPi status : ' + rasPiId + JSON.stringify(rasPiStatus.data));
        return { success: rasPiStatus.data };
      } else {
        return { error: AppConstants.SERVERERR }
      }
    })
    .catch(error => {
      networkError(error, actionRasPiWithBodyAndAckTimeout.name);
      return {
        error: error.response.data.error,
      };
    });
  }
}

export function actionLab(labId, actionId) {
  if (getSession() === AppConstants.SESSIONERR) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.SESSIONERR
      })
    });
  }
  if (!labId) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.NOLab
      })
    });
  } else {
    let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
    return axios.get(controllerEndpoint +
      ApiConstants.VIEW_GROUP_LIST_URL + '/' +
      labId + '/' +
      AppConstants.rasPiAction[actionId].action,
      withHeader(aqtStore.getState().session.idToken.jwtToken))
    .then(rasPiStatus => {
      if (rasPiStatus.hasOwnProperty('data')) {
        logToConsole('RasPi status : ' + JSON.stringify(rasPiStatus.data));
        return { success: rasPiStatus.data };
      } else {
        return { error: AppConstants.SERVERERR }
      }
    })
    .catch(error => {
      networkError(error, actionRasPi.name);
      return {
        error: AppConstants.NETWORKERR
      };
    });
  }
}


export function getWhitelistedScenarios() {
 if (getSession() === AppConstants.SESSIONERR) {
  return new Promise(resolve => {
    resolve({
      error: AppConstants.SESSIONERR
    })
   });
  }
  let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
  return axios.get(controllerEndpoint +
    ApiConstants.GET_WHITELISTED_SCENARIOS,
    withHeader(aqtStore.getState().session.idToken.jwtToken))
    .then(response => {
      if (response.hasOwnProperty('data')) {
      logToConsole('Get whitelisted scenarios: ' + JSON.stringify(response.data));
      return { scenarios: response.data ? response.data  : []};
     } else {
      return { error: AppConstants.SERVERERR }
    }
   })
   .catch(error => {
     networkError(error, getWhitelistedScenarios.name);
     return { error: AppConstants.NETWORKERR };
  }); 
}

export function talkRasPi(labId, rasPiId, fileName, timeOut,
  rasPiControlName = AppConstants.RAS_PI_CONTROL_NAME) {
  if (getSession() === AppConstants.SESSIONERR) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.SESSIONERR
      })
    });
  }
  if (!rasPiId) {
    return new Promise(resolve => {
      resolve({
        error: AppConstants.NORASPI
      })
    });
  } else {
    let controllerEndpoint = aqtStore.getState().environment.controllerEndpoint;
    let body = {
            'waveFileName': fileName,
            'volume': 100,
            'controlName': rasPiControlName
          }
    return axios.post(controllerEndpoint +
      ApiConstants.VIEW_GROUP_LIST_URL + '/' +
      labId + '/' +
      ApiConstants.THINGS + '/' +
      rasPiId + '/' +
      AppConstants.rasPiAction.TALK.action +
      '?actionTimeout=' + timeOut,
      body,
      withHeader(aqtStore.getState().session.idToken.jwtToken))
    .then(rasPiStatus => {
      if (rasPiStatus.hasOwnProperty('data')) {
        logToConsole('RasPi status : ' + JSON.stringify(rasPiStatus.data));
        return { success: rasPiStatus.data };
      } else {
        return { error: AppConstants.SERVERERR }
      }
    })
    .catch(error => {
      networkError(error, talkRasPi.name);
      return {
        error: AppConstants.NETWORKERR
      };
    });
  }
}
